<template lang="pug">   
transition(name="slide-fade")
        v-card
            v-card-title(class="elevation-1") 
                | Configuracion {{Info.Name}}
                v-spacer
                v-btn(icon )  
                    v-icon mdi-close
            v-container( fluid)
                v-row
                    v-col(cols="6" sm="12" md="6") 
                        v-card
                            v-container( fluid)
                                doc-head-field(:apiWeb='_api()',:IdDocType.sync="Info.IdDocType",:IdEnterprise.sync="Info.IdEnterprise") 
                    v-col(v-if="Info.ActiveQuestions==1 || Info.ActiveItems==1  " cols="6" sm="12" md="6")
                        v-card
                            v-container( fluid)
                                v-btn(color="primary" @click="IsShowModalCategory=true") Categorias 
                                        i.fa.fa-plus-circle 
                                v-divider        
                                doc-details-category( :apiWeb='_api()',:IsShowModal.sync="IsShowModalCategory",:IdDocType.sync="Info.IdDocType",@change="List_Info_Categorys()")
                                ul(class="nav nav-tabs" id="myTab" role="tablist"  style="background-color : transparent!important;")
                                    li(class="nav-item" v-if="tablaCategorys" v-for="item of tablaCategorys")
                                        a( v-bind:class="[{active : item.Select},'nav-link']" href="#" @click="reset(item), InfoCategorySelect=item "   ) {{item.Name}}  {{InfoCategorySelect.length}}
                                div(v-if="Info.ActiveQuestions==1")
                                    doc-details-group-question(v-if="InfoCategorySelect.Name",:apiWeb='_api()',:InfoCategory.sync="InfoCategorySelect")
                                div(v-else-if="Info.ActiveItems==1")
                                    doc-item-field(v-if="InfoCategorySelect.Name" :apiWeb='_api()',:IdDocType.sync="Info.IdDocType",:IdEnterprise.sync="Info.IdEnterprise" ,:InfoCategory.sync="InfoCategorySelect")


</template>
<script>
import docDetailsCategory from './docDetails/docCategory/app.vue'
import docDetailsGroupQuestion from './docDetails/docGroupQuestion/app.vue'
import docHeadField from './docHead/app.vue'
import docItemField from './docItems/app.vue'
import apiWeb from "../../api/apiSLC.js"
export default {
    components:{
        docDetailsCategory,
        docDetailsGroupQuestion,
        docHeadField,
        docItemField
    },
    data(){
        return{
            Info:this.$route.query.item,
            IsShowModalCategory:false,
            IsShowModalField:false,
            InfoCategorySelect:{},
            tablaCategorys:[]
        }
    },
    mounted(){
        this.List_Info_Categorys()
    },
    methods:{
        _api(){
            return apiWeb;
        },
        reset(item){
            this.tablaCategorys.forEach(element => {
                if(item.Name==element.Name){
                    element.Select=true 
                }
                else{
                    element.Select=false
                }
            });
          
        },
        List_Info_Categorys(){   
            apiWeb.post("docCategory/docCategory_View",{IdDocType:this.Info.IdDocType, Name:'', Active:1 })
                    .then(result=>{
                                if(result.status==0){
                                    this.tablaCategorys=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
    }
}
</script>
<style scoped>
.nav {
        background-color: transparent!important;
    }
    .slide-fade-enter-active {
      transition: all .5 ease;
    }

    .slide-fade-leave-active {
      transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to{
      transform: translateX(10px);
      opacity: 0;
    } 
</style>